import React, { useState } from 'react';
import styled from 'styled-components';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import DefaultLineTable from '../avalia/DefaultLineTable';
import axios from 'axios';
import { API_HOST } from '../../consts';
import { CSVLink } from 'react-csv';
// import GetAppIcon from '@material-ui/icons/GetApp';
import { IconButton, Button } from '@material-ui/core';
import InsufficientData from '../../components/InsufficientData';
import Loading from '../../components/Loading';

const DivLoading = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  justify-content: center;
  align-items: center;
`;


const ComplexLineChart = ({
  tipo,
  etapa,
  turma,
  dre,
  ano,
  escola,
  idn,
  disciplina,
  titulo,
  tituloCompleto,
  externalData,
  shoudFetch=true
}) => {
  const [dados, setDados] = useState(externalData?externalData:undefined);
  const [fetched, setFetched] = useState(false);

  const fetchData = () => {
    const params = {
      idn: idn,
      tipo: tipo,
      etapa: etapa,
      turma: turma,
      disciplina: disciplina,
      dre: dre,
      ano: ano,
      escola: escola
    };
    axios
      .get(`${API_HOST}/avalia/estudante/get_notas_to_line_chart`, { params })
      .then((response) => {
        setDados(response.data.data);
        setFetched(true)
      })
      .catch((error) => {
        console.error(error)
        setFetched(true)
      })
  };

  if (!fetched&&shoudFetch) {
    fetchData();
  }

  const schoolStage = dados &&dados[0].data.map((item) => {
        return typeof item[0] === 'string' ? item[0] : null;
      }).filter((item) => {
        return item !== null;
      });

  const min = window.location.host.includes('sesi') ? 100 : 0;

  const dadosCSV =
    dados &&
    dados.map((dado) => {
      var etapas = {
        NOME: dado.name
      };
      dado.data.forEach((x) => {
        etapas[x[0]] = x[1] ? x[1].toFixed(2) : '-';
      });
      return etapas;
    });

  var options = {
    chart: {
      height: 600,
      type: 'line',
      events: {
        load: function (event) {
          this.series.forEach(function (d, i) {
            if (d.options.id == 1) d.hide();
          });
        }
      }
    },
    title: {
      text: tituloCompleto ? `${tituloCompleto && tituloCompleto}` : ''
    },
    xAxis: {
      categories: schoolStage,
      labels: {
        rotation: 0,
        style: {
          fontSize: '13px',
          fontFamily: 'Verdana, sans-serif'
        }
      }
    },
    yAxis: {
      min: min,
      title: {
        text: `Proficiência`
      }
    },
    legend: {
      enabled: true,
      layout: 'horizontal',
      borderWidth: 0,
      symbolHeight: 10,
      symbolWidth: 16,
      symbolRadius: 8,
      itemMarginTop: 10,
      maxHeight: 100
    },
    tooltip: {
      formatter: function () {
        return (
          '<b>' +
          this.series.name +
          ': ' +
          this.point.name +
          '</b><br/>' +
          'Proficiência média: ' +
          Highcharts.numberFormat(this.y, 2)
        );
      }
    },
    series: dados
  };

  return (!fetched && dados==undefined) ? (
    <DivLoading>
      <Loading />
    </DivLoading>
  ) : dados !== undefined ? (
    <div
      style={{
        width: '97.5%',
        borderRadius: '8px',
        padding: '1rem',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <div>
        <HighchartsReact highcharts={Highcharts} options={options} />
      </div>
      <div>
        <DefaultLineTable dados={dados} titulo={titulo} />
      </div>
      {dados && (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button>
            <CSVLink data={dadosCSV} filename={tituloCompleto}>
              Baixar gráfico em CSV
            </CSVLink>
          </Button>
        </div>
      )}
    </div>
  ) : (
    <div style={{ height: 'auto', width: '100%' }}>
      <InsufficientData />
    </div>
  );
};

export default styled(ComplexLineChart)`
  display: flex;
  width: 100%;
  height: 100%;
  background-color: #3e2;
  .div {
    color: #3e2;
  }
`;
